import { Button } from "components";
import { useStoreSelectedRows } from "../store/useStoreSetStock";
import { useFormContext } from "react-hook-form";
import { FormSetStockType } from "../schemas/setStockByLocationSchemas";
import toast from "react-hot-toast";
import { useApi } from "utils";
import { PERMISION } from "security";

export function CreateAll(props: {
    refecth?: () => void
}) {

    const api = useApi();

    const { selectedRows } = useStoreSelectedRows()

    const { getValues } = useFormContext<FormSetStockType>()

    const onSubmit = () => {
        const formItems = getValues("items")

        const selectedIds = new Set(selectedRows.map(r => r.product_id))
        const payload = formItems?.filter(item => selectedIds.has(item.product_id!))

        if (payload?.some(item => item?.mr_unit_id === null)) {
            toast.error("Unit product is required")
            return
        }

        return new Promise<void>((resolve) => {
            toast.promise(
                api.post("/product/product-minmax-loc/bulk-upsert", payload),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.detail?.message ?? err.response.data.message
                }
            ).then(() => {
                // props.refecth && props.refecth();
            }).catch(() => {
            }).finally(resolve)
        })

    }

    return (
        <Button
            color="primary"
            permission={PERMISION.INVENTORY.TRANSACTION.SET_STOCK_BY_LOCATION.CREATE}
            onClick={onSubmit}
            disabled={selectedRows.length === 0}
        >
            SAVE
        </Button>
    )
}